import promotionListStore from '@/store/promotion/promotion-list-store'

export default {
  namespaced: true,
  modules: {
    list: promotionListStore
  }
}
